const WATCHLIST_PREFIX = '@PURCHASES';

export const FETCH = `${WATCHLIST_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${WATCHLIST_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${WATCHLIST_PREFIX}/FETCH_ERROR`;

export const LOAD_EXTRA_ITEMS = `${WATCHLIST_PREFIX}/LOAD_EXTRA_ITEMS`;
export const LOAD_EXTRA_ITEMS_SUCCESS = `${WATCHLIST_PREFIX}/LOAD_EXTRA_ITEMS_SUCCESS`;
export const LOAD_EXTRA_ITEMS_ERROR = `${WATCHLIST_PREFIX}/LOAD_EXTRA_ITEMS_ERROR`;
export const LOAD_EXTRA_ITEMS_COMPLETED = `${WATCHLIST_PREFIX}/LOAD_EXTRA_ITEMS_COMPLETED`;

export const RESET_ALL_DATA = `${WATCHLIST_PREFIX}/RESET_ALL_DATA`;
